import React from "react";
import SupportLayout from "../support/SupportLayout";
import AdminFaqs from "./components/AdminFaqs";

const AdminFaqPage = () => {
    return (
        <SupportLayout userRole="ADMIN">
            <div className="pb-40">
                <div className="main_container_title_div mb-5 mt-10">
                    <h1 className="text-3xl sm:text-4xl font-bold text-gray-900">
                        FAQ Management
                    </h1>
                    <p className="text-gray-600 text-xl sm:text-base">
                        Create and manage Frequently Asked Questions
                    </p>
                </div>
                <div className="mt-6">
                    <AdminFaqs />
                </div>
            </div>
        </SupportLayout>
    );
};

export default AdminFaqPage;
